import React from "react";
import { cn } from "../../shared/util/cn";

function toDateTimeLocalValue(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export interface DateTimePickerProps {
  value?: string | null;
  onChange?: (isoString: string | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  label?: string;
  min?: string;
}

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  onChange,
  placeholder = "Data e ora",
  disabled,
  className,
  label,
  min,
}) => {
  const inputValue = toDateTimeLocalValue(value ?? null);

  return (
    <div className={cn("space-y-1", className)}>
      {label && (
        <label className="block text-sm font-semibold text-[var(--color-mockup-text)]">
          {label}
        </label>
      )}
      <input
        type="datetime-local"
        value={inputValue}
        onChange={(e) => {
          const v = e.target.value;
          onChange?.(v ? new Date(v).toISOString() : null);
        }}
        disabled={disabled}
        min={min}
        className={cn(
          "flex h-10 w-full rounded-2xl border-2 border-[var(--color-mockup-border)] bg-surface px-4 py-2 text-sm",
          "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface focus:border-primary",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "dark:border-[var(--color-mockup-border)]"
        )}
        placeholder={placeholder}
      />
    </div>
  );
};
